// Mock data for books
export const books = [
  {
    id: 1,
    title: "Rock Bands Word Search Puzzle Book",
    subtitle: "Word Searches with easy to read print about rock and roll music, rock and roll bands, rock band names",
    author: "RCJ PuzzleBook",
    price: "$9.99",
    amazonLink: "https://www.amazon.com/dp/B0FH7KSD18",
    coverImage: "https://m.media-amazon.com/images/I/61p+UFXbnQL._SY342_.jpg",
    description: "55 epic puzzles across 110 pages, all themed around legendary and alternative rock bands. Perfect brain-bending challenge for all ages.",
    features: [
      "Easy to read print",
      "Hundreds of rock and roll band names",
      "6x9 Inches",
      "Ideal for travel, vacations, home, gifts"
    ],
    pages: 110,
    isbn: "979-8291619339"
  },
  {
    id: 2,
    title: "Brain Training Word Search Book",
    subtitle: "50+ Easy-to-Read Puzzles for Adults and Kids to Expand Your Mind, Sharpen Your Thinking",
    author: "Randy Johnson",
    price: "$9.99",
    amazonLink: "https://www.amazon.com/dp/B0GKY1CWSR",
    coverImage: "https://m.media-amazon.com/images/I/619m1xuUnML._SY342_.jpg",
    description: "Keep Your Mind Sharp with Fun and Relaxing Brain Training Word searches. 55 pages of crisp, high-quality puzzles.",
    features: [
      "Brain training-themed puzzles",
      "Easy-to-read, large print",
      "Engaging vocabulary for mental fitness",
      "Perfect mix of fun and focus"
    ],
    pages: 110,
    isbn: "979-8245946399"
  },
  {
    id: 3,
    title: "Outer Space Expedition Word Search",
    subtitle: "An Interstellar Puzzle Adventure for Kids, Teens, and Space Lovers",
    author: "Randy Johnson",
    price: "$10.99",
    amazonLink: "https://www.amazon.com/dp/B0GKYNTJZ3",
    coverImage: "https://m.media-amazon.com/images/I/61sgRGLXF4L._SY342_.jpg",
    description: "Explore the universe one puzzle at a time! 55 unique outer space word search puzzles packed with cosmic vocabulary.",
    features: [
      "55 unique outer space puzzles",
      "Planets, missions, stars, cosmic science",
      "Large, clear layouts",
      "Great for home, travel, classrooms"
    ],
    pages: 110,
    isbn: "979-8246277041"
  },
  {
    id: 4,
    title: "WW2 Wordsearch",
    subtitle: "55 Large Print Puzzles Featuring WWII Battles, Generals, Aircraft, Weapons, and Historic Events",
    author: "RCJ Puzzlebook",
    price: "$9.99",
    amazonLink: "https://www.amazon.com/dp/B0GTGZBW75",
    coverImage: "https://m.media-amazon.com/images/I/61M1rbyp5aL._AC_SL1500_.jpg",
    description: "Dive into history with 55 large print word search puzzles featuring WWII battles, generals, aircraft, weapons, and historic events.",
    features: [
      "55 WWII-themed puzzles",
      "Large print, easy to read",
      "Battles, generals, aircraft & weapons",
      "Perfect for history buffs"
    ],
    pages: 110,
    isbn: "979-8253088005"
  }
];

export const authorBio = {
  name: "Randy Johnson",
  bio: "Hello, my name is Randy Johnson. I'm an author and puzzle book creator specializing in word search books, brain games, and activity puzzle books for adults, kids, and seniors. I am currently growing a collection of word search puzzle books that make great gifts for puzzle lovers and anyone looking to keep their mind sharp while having fun.",
  image: "https://m.media-amazon.com/images/S/amzn-author-media-prod/q8v51hsll04t16pnjfulnhoubc._SY600_._SL200_._PQ50_._FMwebp_.jpg"
};

// Mock function to save email (legacy - now using real API)
export const saveEmail = async (email) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: 'Email saved successfully!' });
    }, 500);
  });
};
